import type { ReactNode } from 'react'

export type CustomerAreaSectionStat = {
  id?: string
  label: string
  value: ReactNode
  valueClassName?: string
}

type CustomerAreaSectionHeaderProps = {
  eyebrow: string
  title: string
  subtitle?: string
  actions?: ReactNode
  stats?: CustomerAreaSectionStat[]
}

const joinClassNames = (...classNames: Array<string | null | undefined | false>) =>
  classNames.filter(Boolean).join(' ')

export const CustomerAreaSectionHeader = ({
  eyebrow,
  title,
  subtitle,
  actions,
  stats,
}: CustomerAreaSectionHeaderProps) => (
  <header className="ca-card-shell ca-theme-transition rounded-3xl p-6">
    <div className="flex flex-wrap items-start justify-between gap-4">
      <div>
        <p className="text-xs font-semibold uppercase tracking-wide text-(--color-status-success)">{eyebrow}</p>
        <h1 className="mt-1 text-2xl font-semibold tracking-tight text-(--color-text-primary)">{title}</h1>
        {subtitle ? <p className="mt-1 text-sm text-(--color-text-secondary)">{subtitle}</p> : null}
      </div>
      {actions ? <div className="flex flex-wrap gap-2">{actions}</div> : null}
    </div>
    {stats?.length ? (
      <div className="mt-4 grid gap-3 sm:grid-cols-3">
        {stats.map((stat, index) => (
          <div
            key={stat.id ?? `${stat.label}-${index}`}
            className="ca-theme-transition rounded-2xl border border-(--color-border-default) bg-(--color-bg-surface-muted) px-3 py-2"
          >
            <p className="text-xs text-(--color-text-muted)">{stat.label}</p>
            <p className={joinClassNames('text-lg font-semibold text-(--color-text-primary)', stat.valueClassName)}>
              {stat.value}
            </p>
          </div>
        ))}
      </div>
    ) : null}
  </header>
)
